// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"97605147","209":"7719c565","290":"1b3d432b","291":"a5b02d25","483":"299461c7","504":"57dcce8a","546":"90942583","732":"cbde0bd3","787":"b46e151b","945":"68f4d0cf"}[chunkId] + ".chunk.js";
};